import { render, staticRenderFns } from "./ModificarPrepedido.vue?vue&type=template&id=6229033c&scoped=true"
import script from "./ModificarPrepedido.vue?vue&type=script&lang=js"
export * from "./ModificarPrepedido.vue?vue&type=script&lang=js"
import style0 from "./ModificarPrepedido.vue?vue&type=style&index=0&id=6229033c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6229033c",
  null
  
)

export default component.exports